module.exports = __webpack_public_path__ + "img/harvest-logo.f7a4a8b0.svg";